var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10167_18860)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10167_18860",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 1,
    width: 31,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.164551 1.14453H29.2952V37.8719H-0.164551V1.14453Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10167_18860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92179 4.50264C10.2036 3.76292 10.5911 3.08192 11.1664 2.53007C13.4678 0.287442 17.272 0.851034 18.8337 3.66899C20.0078 5.80594 21.2525 7.89593 22.4618 10.0094L28.5205 20.5533C30.1996 23.5004 28.3796 27.2224 25.045 27.7273C23.002 28.0326 21.0881 27.0933 20.0313 25.2616L14.7006 16.0093C14.6654 15.9388 14.6184 15.8801 14.5715 15.8214C14.3836 15.6688 14.3014 15.4457 14.184 15.2461L10.2623 8.44778C9.80437 7.64936 9.59302 6.78049 9.61651 5.86465C9.65173 5.39499 9.71044 4.92533 9.92179 4.50264Z",
    fill: "#3C8BD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92183 4.50391C9.81615 4.9266 9.72222 5.34929 9.69874 5.79547C9.66351 6.78175 9.91009 7.69759 10.4032 8.55472L14.2662 15.2356C14.3836 15.4352 14.4776 15.6348 14.595 15.8227L12.4698 19.4743L9.49913 24.5936C9.45216 24.5936 9.44042 24.5701 9.42868 24.5349C9.41694 24.441 9.45216 24.3588 9.47565 24.2648C9.95705 22.5036 9.55784 20.942 8.34845 19.6035C7.60873 18.7933 6.6694 18.3354 5.58917 18.1827C4.18017 17.9831 2.93556 18.3471 1.82011 19.2277C1.6205 19.3804 1.49134 19.6035 1.25651 19.7209C1.20954 19.7209 1.18606 19.6974 1.17432 19.6622L2.85337 16.7385L9.83964 4.63306C9.86312 4.5861 9.89834 4.55087 9.92183 4.50391Z",
    fill: "#FABC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22136 19.6957L1.89063 19.0969C4.74385 16.8425 9.02954 18.4746 9.65184 22.044C9.80449 22.9011 9.72229 23.723 9.46398 24.545C9.45224 24.6154 9.4405 24.6741 9.41701 24.7446C9.31134 24.9324 9.21741 25.132 9.09999 25.3199C8.05498 27.0459 6.51683 27.903 4.49727 27.7739C2.18417 27.6095 0.364219 25.8717 0.0471948 23.5704C-0.105446 22.455 0.117645 21.41 0.692984 20.4472C0.810401 20.2358 0.9513 20.048 1.08046 19.8366C1.13917 19.7897 1.11568 19.6957 1.22136 19.6957Z",
    fill: "#34A852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22191 19.6956C1.17473 19.7428 1.17473 19.8254 1.09217 19.8371C1.08037 19.7546 1.12755 19.7074 1.17473 19.6484L1.22191 19.6956Z",
    fill: "#FABC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41697 24.747C9.36987 24.6646 9.41697 24.6057 9.46406 24.5469L9.51116 24.594L9.41697 24.747Z",
    fill: "#E1C025"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10167_18860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.155,
    height: 29.155,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google_ads.62a6d244b197f119c716efc6f121c43a.svg";
export { ForwardRef as ReactComponent };